import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Switch,
} from '@mui/material';

const RoleDialog = ({ open, user, onClose, onRoleChange }) => {
  const hasAdminRole = user?.roles?.includes('ADMIN') || false;

  const handleRoleToggle = (role, checked) => {
    if (user) {
      onRoleChange(user.userId, role, checked);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Manage Roles for {user?.name}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Toggle ADMIN role for this user. USER role is default and cannot be
            removed.
          </Typography>

          {/* USER Role Toggle */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 2,
              mb: 2,
              bgcolor: '#f8fafc',
              borderRadius: 2,
              border: '1px solid #e2e8f0',
              opacity: 0.7,
            }}
          >
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                USER Role
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Default role - Always enabled
              </Typography>
            </Box>
            <Switch checked={true} disabled={true} color="primary" />
          </Box>

          {/* ADMIN Role Toggle */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 2,
              bgcolor: '#fef2f2',
              borderRadius: 2,
              border: '1px solid #fecaca',
            }}
          >
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, color: '#dc2626' }}
              >
                ADMIN Role
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Full administrative access
              </Typography>
            </Box>
            <Switch
              checked={hasAdminRole}
              onChange={(e) => handleRoleToggle('ADMIN', e.target.checked)}
              color="error"
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: '#232536',
            color: '#232536',
            '&:hover': {
              borderColor: '#232536',
              bgcolor: '#f8fafc',
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoleDialog;
